module.exports = __webpack_public_path__ + "img/es.359530a5.svg";